export const DELIVERY_DATE_TODAY_KEY = 'today';

export function utilFormatDeliveryDate(value: string): string {
  if (!value) return '';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return value;

  const today = new Date();

  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return DELIVERY_DATE_TODAY_KEY;
  }

  const dateStr = date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
  const weekdayStr = date.toLocaleDateString('ru-RU', { weekday: 'long' });

  return `${dateStr}, ${weekdayStr}`;
}
